/* global app */
export default class LabelPresenter {
    static present (labels = []) {
        let colors = app.config.LABEL_COLORS || []

        return labels.sort((a, b) => {
            let aColor = colors.indexOf(a.color)
            let bColor = colors.indexOf(b.color)

            if (aColor < bColor) {
                return -1
            }
            if (aColor > bColor) {
                return 1
            }

            if (a.name < b.name) {
                return -1
            }
            if (a.name > b.name) {
                return 1
            }

            return 0
        })
    }
}
